import { HTMLStyledProps, styled } from '@repo/themes/styled-system/jsx';
import { miniCardRecipe } from '@repo/themes/styled-system/recipes';

export const MiniCard = styled('div', miniCardRecipe);
export type MiniCardProps = HTMLStyledProps<typeof MiniCard>;
